// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import '@/assets/styles/app.css'
import '@/assets/styles/common.css'
import '@/assets/styles/font.css'
import '@/assets/styles/snackbar.css'
import '@/assets/styles/dropdown.css'
import 'vue-datetime/dist/vue-datetime.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueChatScroll from 'vue-chat-scroll'
import Popover from 'vue-js-popover'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import ToggleButton from 'vue-js-toggle-button'
import store from './store'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import ably from './core/ably'
import { onSuccess, onError, beforeRequestSuccess } from './interceptors/loader'
import Snackbar from '@/components/common/snackbar'
import localforage from 'localforage'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import VueApexCharts from 'vue-apexcharts'

let environment = ''
if (window.location.host === 'consultations.ekincare.com') {
  environment = 'production'
} else if (window.location.host === 'doctorstaging.ekincare.com') {
  environment = 'staging'
} else {
  environment = 'development'
}
Raven
  .config('https://88811500135a45ae856d3aa4bb627e8b@sentry.io/1210314', {
    environment: environment
  })
  .addPlugin(RavenVue, Vue)
  .install()

Sentry.init({
  dsn: 'https://88811500135a45ae856d3aa4bb627e8b@o65160.ingest.us.sentry.io/1210314',
  environment: environment,
  integrations: [
    new Integrations.BrowserTracing() // Enable tracing
  ],
  tracesSampleRate: 1.0
})

export const Bus = new Vue()
const Ably = {
  install (Vue, options) {
    Vue.realtime = function () {
      return ably
    }
  }
}

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueChatScroll)
Vue.use(VeeValidate)
Vue.use(Popover)
Vue.use(Ably)
Vue.use(ToggleButton)
Vue.use(Snackbar)
Vue.use(VueApexCharts)

Vue.http.interceptors.push((request, next) => {
  request.headers.set('X-DOCTOR-KEY', sessionStorage.getItem('X-DOCTOR-KEY'))
  beforeRequestSuccess(request)
  next(function (response) {
    if (response.status === 200) {
      onSuccess()
    } else if (response.status === 401) {
      sessionStorage.clear()
      ably.close()
      store.dispatch('clearAll')
      window.location.href = '/login'
    } else {
      onError()
      // alert('Something went wrong')
    }
  })
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY, h:mm A')
  }
})

Vue.filter('formatDateIST', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('DD MMM YYYY, h:mm A')
  }
})

Vue.filter('formatDateWithoutTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY')
  }
})
Vue.filter('formatDateMonth', function (value) {
  if (value) {
    return moment(value, 'DD/MM/YYYY').format('Do MMM')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

// Check user logged in
if (sessionStorage.getItem('X-DOCTOR-KEY') !== undefined && sessionStorage.getItem('X-DOCTOR-KEY') !== null) {
  store.dispatch('configuration/init')
}

localforage.config({
  driver: localforage.INDEXEDDB, // Force INDEXEDDB; same as using setDriver()
  name: 'audits',
  version: 1.0,
  storeName: 'audits', // Should be alphanumeric, with underscores.
  description: 'This is to track events'
})
localforage.getItem('audits', function (err, data) {
  if (err === null && data === null) {
    localforage.setItem('audits', [])
  }
})



// WEBPACK FOOTER //
// ./src/main.js